var map = {
	"./backpack.png": "559f",
	"./close.png": "cd5c",
	"./digits.png": "f1fe",
	"./food.png": "5f0a",
	"./health.png": "e7b1",
	"./idCard.png": "d816",
	"./inventory.png": "bf0d",
	"./lock.png": "5612",
	"./notebook-icon.png": "5c4b",
	"./notebook.png": "a927",
	"./notebook/0.png": "78c1",
	"./notebook/1.png": "a834",
	"./notebook/2.png": "5592",
	"./notebook/3.png": "808d",
	"./notebook/4.png": "4040",
	"./notebook/5.png": "b675",
	"./notebook/6.png": "7815",
	"./notebook/7.png": "819e",
	"./notebook/8.png": "ba04",
	"./notebook/9.png": "d9b9",
	"./water.png": "b2c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";